'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.addWeeks;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/addWeeks.js
// module id = 245
// module chunks = 0